<template>
  <a-modal
    :visible="visible"
    :width="960"
    :bodyStyle="{ height: '560px' }"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    centered
  >
    <template slot="title">
      <div style="display: flex">
        <span style="font-size: 18px; font-weight: 800; margin-right: 24px">团队分配</span>
        <div class="frontSite">（共筛选出</div>
        <div class="frontSite" style="color: #1991ff">{{ total }}</div>
        <div class="frontSite">个站点）</div>
      </div>
    </template>
    <a-form-model :layout="layout" :model="form" :rules="rules" ref="form1">
      <a-form-model-item label="选择负责团队" prop="groupId">
        <a-select allowClear v-model="form.groupId" style="width: 100%" @select="selectValue">
          <a-select-option v-for="(item, index) in dataGroup" :key="index" :value="item.id">
            {{ item.groupName }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="团队成员" prop="memberIdList">
        <a-select
          allowClear
          v-model="form.memberIdList"
          style="width: 100%"
          mode="multiple"
          :disabled="true"
        >
          <a-select-option v-for="(item, index) in peopleGroup" :key="index" :value="item.id">
            {{ item.userDto.userName }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { info } from '@/api/System/User'
import { detail, allot } from '@/api/Monitor/abnormal'
export default {
  props: {
    selectedRowKeys: {
      default: []
    },
    total: { default: '' }
  },
  data() {
    return {
      confirmLoading: false,
      visible: false,
      layout: 'horizontal',
      form: {
        groupId: undefined,
        memberIdList: undefined
      },
      dataGroup: [],
      peopleGroup: [],
      rules: {
        // memberIdList: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        groupId: [{ required: true, message: '请选择负责团队', trigger: 'blur' }]
        // people: [{ required: true, message: '请选择用户组成员', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.leftData()
  },
  methods: {
    selectValue(value) {
      this.dataGroup.forEach((element) => {
        if (element.id === value) {
          if (element.userGroupMemberDtoList) {
            this.peopleGroup = element.userGroupMemberDtoList
            let a = []
            element.userGroupMemberDtoList.forEach((elements) => {
              a.push(elements.id)
            })
            this.form.memberIdList = a
          } else {
            this.peopleGroup = []
            this.form.memberIdList = []
          }
        }
      })
    },
    leftData() {
      info().then((res) => {
        this.dataGroup = res.data
      })
    },
    showModel() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.info('请选择站点')
      } else {
        this.form = {
          groupId: undefined,
          memberIdList: undefined
        }
        this.visible = true
      }
    },
    handleOk(e) {
      // this.ModalText = 'The modal will be closed after two seconds'
      // this.confirmLoading = true
      // setTimeout(() => {
      //   this.visible = false
      //   this.confirmLoading = false
      // }, 2000)
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.confirmLoading = true
          let param = { ...this.form }
          param.idList = this.selectedRowKeys
          allot(param).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.visible = false
              this.$emit('reload')
            } else {
              this.$message.error(res.msg)
            }

            this.confirmLoading = false
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.frontSite {
  font-size: 18px;
  font-weight: 400;
  color: #595959;
}
</style>
<style></style>
